'use strict'
class ShowMoreProducts {
    static show(event, nextPage, id, ajaxId) {
        event.target.classList.add('loading')
        /**
         * Защита от повторного нажатия. Удаляем атрибут так как элемент всё равно будет заменён тем что придёт из ajax
         */
        event.target.removeAttribute('onclick')
        let xmlHttp = new XMLHttpRequest()
        xmlHttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                document.getElementById('btn_' + ajaxId).remove()
                document.querySelector('.pagination').remove()
                document.getElementById('comp_' + ajaxId).insertAdjacentHTML('beforeend', xmlHttp.responseText)
            }
        }
        let url = new URL(window.location.href)
        url.searchParams.set('PAGEN_' + id, nextPage)
        url.searchParams.set('bxajaxid', ajaxId)
        xmlHttp.open('GET', url, true)
        xmlHttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        xmlHttp.send()
        return true
    }
}
window.TimeCity = window.TimeCity || {};
window.TimeCity.ShowMoreProducts = ShowMoreProducts;